/**
 * The shell icon set, as a typed sprite.
 *
 * Ported from the prototype rather than swapped for an icon library: Lucide's
 * metaphors do not cover rectifier, busway, RPP, DC bus, ATS or STS — and those
 * are precisely the icons that carry meaning here.
 *
 * stroke-width 2 at 15–17px is the prototype's actual weight and reads
 * correctly at this density. "Ultra-light lines" would lose legibility.
 */
import type { ReactNode } from 'react';

import { PATHS, type IconName } from './icon-paths';

export type { IconName } from './icon-paths';

export interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
}

export function Icon({ name, size = 16, className }: IconProps): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={{ flex: 'none' }}
      aria-hidden
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
